module.exports = __webpack_public_path__ + "images/upgrade_contact.webp";